;
(function(){
  var sticky = document.getElementById('advSticky');
  if(!sticky) return;
  var threshold = 0.15;
  var ticking = false;
  function check(){
    var scrolled = window.scrollY || window.pageYOffset;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var pct = docHeight > 0 ? scrolled / docHeight : 0;
    if(pct >= threshold){
      sticky.classList.add('adv-sticky-visible');
    } else {
      sticky.classList.remove('adv-sticky-visible');
    }
    ticking = false;
  }
  window.addEventListener('scroll', function(){
    if(!ticking){
      window.requestAnimationFrame(check);
      ticking = true;
    }
  });
  check();
})();

;
(function(){
  var sticky = document.getElementById('om-sticky-bar');
  if (!sticky) return;
  var shown = false;
  function checkScroll() {
    var scrollPct = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
    if (scrollPct > 0.20 && !shown) {
      sticky.classList.add('om-sticky--visible');
      shown = true;
    } else if (scrollPct <= 0.15 && shown) {
      sticky.classList.remove('om-sticky--visible');
      shown = false;
    }
  }
  window.addEventListener('scroll', checkScroll, { passive: true });
})();
